// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1-3ux","requiredAsterisk":"Info_requiredAsterisk__1GE_p"};